import en from "./en-US.json";
import zh from "./zh-CN.json";
export default {
  en,
  zh
};
